import { createSelector } from '@ngrx/store';
import { docsFeature } from './docs.reducer';
import { DocStatus } from './docs.models';
import { docKey } from './docs.normalize';

const { selectEntities, selectKeyIndex, selectStatusByKey } = docsFeature;

export const selectDoc = (projectId: string, key: string) =>
  createSelector(selectEntities, selectKeyIndex, (entities, keyIndex) => {
    const id = keyIndex[docKey(projectId, key)];
    return id ? entities.entities[id] ?? null : null;
  });

export const selectDocData = (projectId: string, key: string) =>
  createSelector(selectDoc(projectId, key), (doc) => (doc?.data ?? null));

export const selectDocStatus = (projectId: string, key: string) =>
  createSelector(selectStatusByKey, (statusByKey): DocStatus => statusByKey[docKey(projectId, key)] ?? 'idle');

const selectAllDocs = createSelector(selectEntities, (e) =>
  (e.ids as string[]).map((id) => e.entities[id]).filter(Boolean)
);
